export default __webpack_public_path__ + "static/media/web-screenshot.7cab1cac.png";